import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Popup} from 'semantic-ui-react';

import {WBTableRowWithRunSetInfo} from '../../util/tablecols';
import {MultiStateCheckbox} from '../MultiStateCheckbox';

type RowHeaderVisCheckboxProps = {
  row: WBTableRowWithRunSetInfo;
  recursionDepth: number;
  runIsInBounds: boolean | null;
  visCheckboxState: 'checked' | 'unchecked' | 'partial' | 'unknown';
  toggleSelection: (run: WBTableRowWithRunSetInfo, depth: number) => void;
  isInReport?: boolean;
};

export const RowHeaderVisCheckbox: React.FC<RowHeaderVisCheckboxProps> = ({
  row,
  recursionDepth,
  runIsInBounds,
  visCheckboxState,
  toggleSelection,
  isInReport,
}) => {
  const checkbox = (
    <MultiStateCheckbox
      data-test="run-visibility-checkbox"
      checked={visCheckboxState}
      aria-label={visCheckboxState === 'checked' ? 'Hide run' : 'Show run'}
      onClick={() => {
        toggleSelection(row, recursionDepth + 1);
        window.analytics?.track('Run visibility toggled', {
          location: isInReport ? 'report' : 'runs table',
        });
      }}
      theme="visibility"
    />
  );

  if (runIsInBounds == null) {
    return checkbox;
  }
  if (runIsInBounds) {
    return checkbox;
  }
  return (
    <Popup
      inverted
      position="right center"
      content="This run is hidden by a parallel coordinates or scatter plot. Deselect the range on that chart first."
      size="mini"
      on="hover"
      trigger={checkbox}
      offset={-3}
      popperModifiers={{
        preventOverflow: {
          // prevent popper from erroneously constraining the popup to the
          // table header
          boundariesElement: 'viewport',
        },
      }}
    />
  );
};
